module.exports = __webpack_public_path__ + "static/media/login-image.5dc4ff53.png";